export const avalanchePools = [
  {
    id: 'gondola-eth-zeth',
    logo: 'avax-pairs/ZETH.svg',
    name: 'zETH-ETH LP',
    token: 'zETH-ETH LP',
    tokenDescription: 'Gondola',
    tokenAddress: '0xc37ECFA7Bbf1dF92Da7C4A3d92d8CF8657D1FF7f',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooGondolaZETH-ETH',
    earnedTokenAddress: '0xC1CD225fe92bA4f3771719a1e0e44ef72E19D489',
    earnContractAddress: '0xC1CD225fe92bA4f3771719a1e0e44ef72E19D489',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'gondola-eth-zeth',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Gondola',
    assets: ['zETH', 'ETH'],
    callFee: 0.5,
    addLiquidityUrl: 'https://app.gondola.finance/#/deposit/eth',
    buyTokenUrl: 'https://app.gondola.finance/#/swap/eth',
  },
  {
    id: 'gondola-usdt-zusdt',
    logo: 'single-assets/USDT.svg',
    name: 'zUSDT-USDT LP',
    token: 'zUSDT-USDT LP',
    tokenDescription: 'Gondola',
    tokenAddress: '0xE586dB7Db75B87A3E84110a73b99960F5f106c6A',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooGondolaZUSDT-USDT',
    earnedTokenAddress: '0xEbAE4810Fd13605957e7D90bd49d2fD8F8148923',
    earnContractAddress: '0xEbAE4810Fd13605957e7D90bd49d2fD8F8148923',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'gondola-usdt-zusdt',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Gondola',
    assets: ['zUSDT', 'USDT'],
    callFee: 0.5,
    addLiquidityUrl: 'https://app.gondola.finance/#/deposit/usdt',
    buyTokenUrl: 'https://app.gondola.finance/#/swap/usdt',
  },
  {
    id: 'gondola-dai-zdai',
    logo: 'single-assets/DAI.svg',
    name: 'zDAI-DAI LP',
    token: 'zDAI-DAI LP',
    tokenDescription: 'Gondola',
    tokenAddress: '0x2036C0EB5C42eF7f1ca06dF57D07F79eb3a2e0C8',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooGondolaZDAI-DAI',
    earnedTokenAddress: '0x5090DC83607036e93412B7739ccf3338086e885e',
    earnContractAddress: '0x5090DC83607036e93412B7739ccf3338086e885e',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'gondola-dai-zdai',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Gondola',
    assets: ['zDAI', 'DAI'],
    callFee: 0.5,
    addLiquidityUrl: 'https://app.gondola.finance/#/deposit/dai',
    buyTokenUrl: 'https://app.gondola.finance/#/swap/dai',
  },
  {
    id: 'lyd-lyd-usdt',
    logo: 'usdt-pairs/LYD-USDT.png',
    name: 'LYD-USDT LP',
    token: 'LYD-USDT LP',
    tokenDescription: 'Lydia',
    tokenAddress: '0x752C59f22fAAA861108649F4596034796C69bC3f',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooLydiaLYD-USDT',
    earnedTokenAddress: '0xc44d493B6219A7f5C286724b74c158CEBd7fB6f7',
    earnContractAddress: '0xc44d493B6219A7f5C286724b74c158CEBd7fB6f7',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'lyd-lyd-usdt',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Lydia',
    assets: ['LYD', 'USDT'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://www.lydia.finance/#/add/0x4c9b4e1ac6f24cde3660d5e4ef1ebf77c710c084/0xde3a24028580884448a5397872046a019649b084',
    buyTokenUrl:
      'https://exchange.lydia.finance/#/swap?inputCurrency=0x4c9b4e1ac6f24cde3660d5e4ef1ebf77c710c084&outputCurrency=0xde3a24028580884448a5397872046a019649b084',
  },
  {
    id: 'lyd-lyd-avax',
    logo: 'avax-pairs/LYD-AVAX.png',
    name: 'LYD-AVAX LP',
    token: 'LYD-AVAX LP',
    tokenDescription: 'Lydia',
    tokenAddress: '0xFba4EdaAd3248B03f1a3261ad06Ad846A8e50765',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooLydiaLYD-AVAX',
    earnedTokenAddress: '0x994aB71F95A8de4dAaF6DE3D9862284693fB2bDf',
    earnContractAddress: '0x994aB71F95A8de4dAaF6DE3D9862284693fB2bDf',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'lyd-lyd-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Lydia',
    assets: ['LYD', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://www.lydia.finance/#/add/0x4c9b4e1ac6f24cde3660d5e4ef1ebf77c710c084/0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
    buyTokenUrl:
      'https://exchange.lydia.finance/#/swap?inputCurrency=0x4c9b4e1ac6f24cde3660d5e4ef1ebf77c710c084&outputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
  },
  {
    id: 'olive-olive-avax',
    logo: 'avax-pairs/OLIVE-AVAX.png',
    name: 'OLIVE-AVAX LP',
    token: 'OLIVE-AVAX LP',
    tokenDescription: 'OliveSwap',
    tokenAddress: '0x57cc32Cd7F5a531953E9af25e1C9394093428082',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooOliveOLIVE-AVAX',
    earnedTokenAddress: '0x9Bb9B11917e7bC3528B6048E9B01cD5E302bb27B',
    earnContractAddress: '0x9Bb9B11917e7bC3528B6048E9B01cD5E302bb27B',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'olive-olive-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'OliveSwap',
    assets: ['OLIVE', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://swap.olive.cash/#/add/AVAX/0x617724974218A18769020A70162165A539c07E8a',
    buyTokenUrl:
      'https://swap.olive.cash/#/swap?outputCurrency=0x617724974218A18769020A70162165A539c07E8a',
  },
  {
    id: 'olive-olive-usdt',
    logo: 'avax-pairs/OLIVE-USDT.png',
    name: 'OLIVE-USDT LP',
    token: 'OLIVE-USDT LP',
    tokenDescription: 'OliveSwap',
    tokenAddress: '0xF54a719215622f602FCA5BF5a6509734C3574a4c',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooOliveOLIVE-USDT',
    earnedTokenAddress: '0xBdA8bC79705BC60226adCA2766e94Eb5512949a3',
    earnContractAddress: '0xBdA8bC79705BC60226adCA2766e94Eb5512949a3',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'olive-olive-usdt',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'OliveSwap',
    assets: ['OLIVE', 'USDT'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://swap.olive.cash/#/add/0xde3A24028580884448a5397872046a019649b084/0x617724974218A18769020A70162165A539c07E8a',
    buyTokenUrl:
      'https://swap.olive.cash/#/swap?outputCurrency=0x617724974218A18769020A70162165A539c07E8a',
  },

  {
    id: 'snob-3pool',
    logo: 'avax-pairs/SNOB3P.png',
    name: 'USDT/BUSD/DAI',
    token: 'Snob 3Pool',
    tokenDescription: 'Snowball',
    tokenAddress: '0xdE1A11C331a0E45B9BA8FeE04D4B51A745f1e4A4',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooSnob3Pool',
    earnedTokenAddress: '0x0a350c62f4b8C7dA93fBca469e53a182b5BBD044',
    earnContractAddress: '0x0a350c62f4b8C7dA93fBca469e53a182b5BBD044',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'snob-3pool',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Snowball',
    assets: ['USDT', 'BUSD', 'DAI'],
    callFee: 0.25,
    addLiquidityUrl: 'https://snowball.network/stablevault/',
  },

  {
    id: 'com-usdt-avax',
    logo: 'avax-pairs/USDT-AVAX.png',
    name: 'USDT-AVAX LP',
    token: 'USDT-AVAX CLP',
    tokenDescription: 'Complus',
    tokenAddress: '0xe64bfAe83BA234aB85BceF5B7A92427E29b3AA11',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooComplusUSDT-AVAX',
    earnedTokenAddress: '0x14d07853560436aEe38BE12DD66d944B07D5E59F',
    earnContractAddress: '0x14d07853560436aEe38BE12DD66d944B07D5E59F',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'com-usdt-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Complus',
    assets: ['USDT', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://avadex.complus.exchange/#/add/AVAX/0xde3A24028580884448a5397872046a019649b084',
    buyTokenUrl:
      'https://avadex.complus.exchange/#/swap?inputCurrency=0xde3A24028580884448a5397872046a019649b084&outputCurrency=AVAX',
  },
  {
    id: 'com-eth-avax',
    logo: 'avax-pairs/ETH-AVAX.png',
    name: 'ETH-AVAX LP',
    token: 'ETH-AVAX CLP',
    tokenDescription: 'Complus',
    tokenAddress: '0x0CA373D27CE17C4804D108afEee0A77EfEb33775',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooComplusETH-AVAX',
    earnedTokenAddress: '0x0c89Ca08b6831e6b81f9f969F37A966a2C44d3d1',
    earnContractAddress: '0x0c89Ca08b6831e6b81f9f969F37A966a2C44d3d1',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'com-eth-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Complus',
    assets: ['ETH', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://avadex.complus.exchange/#/add/AVAX/0xf20d962a6c8f70c731bd838a3a388D7d48fA6e15',
    buyTokenUrl:
      'https://avadex.complus.exchange/#/swap?inputCurrency=0xf20d962a6c8f70c731bd838a3a388D7d48fA6e15&outputCurrency=AVAX',
  },
  {
    id: 'com-png-avax-eol',
    logo: 'avax-pairs/PNG-AVAX.png',
    name: 'PNG-AVAX LP',
    token: 'PNG-AVAX CLP',
    tokenDescription: 'Complus',
    tokenAddress: '0xEcee953e187d9e82D57bAedAaEF1e56E5283f5C3',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooComplusPNG-AVAX',
    earnedTokenAddress: '0x7076a33b6525132fF77F0FeE2daB2a1e79688DA0',
    earnContractAddress: '0x7076a33b6525132fF77F0FeE2daB2a1e79688DA0',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'com-png-avax',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    platform: 'Complus',
    assets: ['PNG', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://avadex.complus.exchange/#/add/AVAX/0x60781C2586D68229fde47564546784ab3fACA982',
    buyTokenUrl:
      'https://avadex.complus.exchange/#/swap?inputCurrency=0x60781C2586D68229fde47564546784ab3fACA982&outputCurrency=AVAX',
  },

  {
    id: 'snob-snob-avax',
    logo: 'avax-pairs/SNOB-AVAX.svg',
    name: 'SNOB-AVAX LP',
    token: 'SNOB-AVAX LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0xa1C2c3B6b120cBd4Cec7D2371FFd4a931A134A32',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooSnowballSNOB-AVAX',
    earnedTokenAddress: '0x114c5f7f42fB75b7960aa3e4c327f53288360F58',
    earnContractAddress: '0x114c5f7f42fB75b7960aa3e4c327f53288360F58',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'snob-snob-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Snowball',
    assets: ['SNOB', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/AVAX/0xC38f41A296A4493Ff429F1238e030924A1542e50',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0xC38f41A296A4493Ff429F1238e030924A1542e50',
  },

  {
    id: 'com-com-avax',
    logo: 'avax-pairs/COM-AVAX.png',
    name: 'COM-AVAX LP',
    token: 'COM-AVAX LP',
    tokenDescription: 'Complus',
    tokenAddress: '0xF0ED25fD26E0b64C86c6c78b661F2ef283E9B6FF',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooComplusCOM-AVAX',
    earnedTokenAddress: '0xA43d8f6Db69610C8260B953658553cabF01D77c6',
    earnContractAddress: '0xA43d8f6Db69610C8260B953658553cabF01D77c6',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'com-com-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Complus',
    assets: ['COM', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://avadex.complus.exchange/#/add/AVAX/0x3711c397B6c8F7173391361e27e67d72F252cAad',
    buyTokenUrl:
      'https://avadex.complus.exchange/#/swap?inputCurrency=0x3711c397B6c8F7173391361e27e67d72F252cAad&outputCurrency=AVAX',
  },

  {
    id: 'com-dai-avax',
    logo: 'avax-pairs/DAI-AVAX.png',
    name: 'DAI-AVAX LP',
    token: 'DAI-AVAX LP',
    tokenDescription: 'Complus',
    tokenAddress: '0x7583a59a50d761E491d0c9393cA5214dbB613806',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooComplusDAI-AVAX',
    earnedTokenAddress: '0xB5F0fF997BEc850b11792ed07b2B5AbDEa869B84',
    earnContractAddress: '0xB5F0fF997BEc850b11792ed07b2B5AbDEa869B84',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'com-dai-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Complus',
    assets: ['DAI', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://avadex.complus.exchange/#/add/AVAX/0xbA7dEebBFC5fA1100Fb055a87773e1E99Cd3507a',
    buyTokenUrl:
      'https://avadex.complus.exchange/#/swap?inputCurrency=0xbA7dEebBFC5fA1100Fb055a87773e1E99Cd3507a&outputCurrency=AVAX',
  },

  {
    id: 'png-sushi-avax',
    logo: 'avax-pairs/SUSHI-AVAX.svg',
    name: 'SUSHI-AVAX LP',
    token: 'SUSHI-AVAX LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0xd8B262C0676E13100B33590F10564b46eeF652AD',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooPangolinSUSHI-AVAX',
    earnedTokenAddress: '0x3094Ab4Af54f5208B867125B5CCeCc94Bc17cbB6',
    earnContractAddress: '0x3094Ab4Af54f5208B867125B5CCeCc94Bc17cbB6',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'png-sushi-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Pangolin',
    assets: ['SUSHI', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/AVAX/0x39cf1BD5f15fb22eC3D9Ff86b0727aFc203427cc',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0x39cf1BD5f15fb22eC3D9Ff86b0727aFc203427cc',
  },

  {
    id: 'png-wbtc-avax',
    logo: 'avax-pairs/WBTC-AVAX.svg',
    name: 'WBTC-AVAX LP',
    token: 'WBTC-AVAX LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0x7a6131110B82dAcBb5872C7D352BfE071eA6A17C',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooPangolinWBTC-AVAX',
    earnedTokenAddress: '0xd5ab3Fac6200B0D8e8d76daED62793026118A78c',
    earnContractAddress: '0xd5ab3Fac6200B0D8e8d76daED62793026118A78c',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'png-wbtc-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Pangolin',
    assets: ['WBTC', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/AVAX/0x408D4cD0ADb7ceBd1F1A1C33A0Ba2098E1295bAB',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0x408D4cD0ADb7ceBd1F1A1C33A0Ba2098E1295bAB',
  },

  {
    id: 'png-link-avax',
    logo: 'avax-pairs/LINK-AVAX.svg',
    name: 'LINK-AVAX LP',
    token: 'LINK-AVAX LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0xbbC7fFF833D27264AaC8806389E02F717A5506c9',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooPangolinLINK-AVAX',
    earnedTokenAddress: '0x6571052b2FB67DF6DD003ED6ed371098A030Eb0d',
    earnContractAddress: '0x6571052b2FB67DF6DD003ED6ed371098A030Eb0d',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'png-link-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Pangolin',
    assets: ['LINK', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/AVAX/0xB3fe5374F67D7a22886A0eE082b2E2f9d2651651',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0xB3fe5374F67D7a22886A0eE082b2E2f9d2651651',
  },

  {
    id: 'png-uni-avax',
    logo: 'avax-pairs/UNI-AVAX.svg',
    name: 'UNI-AVAX LP',
    token: 'UNI-AVAX LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0x92dC558cB9f8d0473391283EaD77b79b416877cA',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooPangolinUNI-AVAX',
    earnedTokenAddress: '0x17657955D954bD7F7315C388D7099af7B0b851FA',
    earnContractAddress: '0x17657955D954bD7F7315C388D7099af7B0b851FA',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'png-uni-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Pangolin',
    assets: ['UNI', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/AVAX/0xf39f9671906d8630812f9d9863bBEf5D523c84Ab',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0xf39f9671906d8630812f9d9863bBEf5D523c84Ab',
  },

  {
    id: 'png-usdt-png',
    logo: 'avax-pairs/USDT-PNG.svg',
    name: 'USDT-PNG LP',
    token: 'USDT-PNG LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0xE8AcF438B10A2C09f80aEf3Ef2858F8E758C98F9',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooPangolinUSDT-PNG',
    earnedTokenAddress: '0x044e87f30bd9bD961c04028aC69155493E1b9eD0',
    earnContractAddress: '0x044e87f30bd9bD961c04028aC69155493E1b9eD0',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'png-usdt-png',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Pangolin',
    assets: ['USDT', 'PNG'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/0x60781C2586D68229fde47564546784ab3fACA982/0xde3A24028580884448a5397872046a019649b084',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0xde3A24028580884448a5397872046a019649b084',
  },

  {
    id: 'png-eth-avax',
    logo: 'avax-pairs/ETH-AVAX.svg',
    name: 'ETH-AVAX LP',
    token: 'ETH-AVAX LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0x1aCf1583bEBdCA21C8025E172D8E8f2817343d65',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooPangolinETH-AVAX',
    earnedTokenAddress: '0xDA875A511860f2752B891677489d08CaEDac00EA',
    earnContractAddress: '0xDA875A511860f2752B891677489d08CaEDac00EA',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'png-eth-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Pangolin',
    assets: ['ETH', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/AVAX/0xf20d962a6c8f70c731bd838a3a388D7d48fA6e15',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0xf20d962a6c8f70c731bd838a3a388D7d48fA6e15',
  },

  {
    id: 'png-usdt-avax',
    logo: 'avax-pairs/USDT-AVAX.svg',
    name: 'USDT-AVAX LP',
    token: 'USDT-AVAX LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0x9EE0a4E21bd333a6bb2ab298194320b8DaA26516',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooPangolinUSDT-AVAX',
    earnedTokenAddress: '0x7a670e849DB824364d1031DEAfB4cD603144F23D',
    earnContractAddress: '0x7a670e849DB824364d1031DEAfB4cD603144F23D',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'png-usdt-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Pangolin',
    assets: ['USDT', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/AVAX/0xde3A24028580884448a5397872046a019649b084',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0xde3A24028580884448a5397872046a019649b084',
  },

  {
    id: 'png-png-avax',
    logo: 'avax-pairs/PNG-AVAX.svg',
    name: 'PNG-AVAX LP',
    token: 'PNG-AVAX LP',
    tokenDescription: 'Pangolin',
    tokenAddress: '0xd7538cABBf8605BdE1f4901B47B8D42c61DE0367',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooPangolinPNG-AVAX',
    earnedTokenAddress: '0x71b5852857b85D5096d4288AD6d293F217d8e162',
    earnContractAddress: '0x71b5852857b85D5096d4288AD6d293F217d8e162',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'png-png-avax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Pangolin',
    assets: ['PNG', 'AVAX'],
    callFee: 0.25,
    addLiquidityUrl:
      'https://app.pangolin.exchange/#/add/AVAX/0x60781C2586D68229fde47564546784ab3fACA982',
    buyTokenUrl:
      'https://app.pangolin.exchange/#/swap?inputCurrency=0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7&outputCurrency=0x60781C2586D68229fde47564546784ab3fACA982',
  },
];
